export const componentStyles = {
  logoStyle: {
    width: "65%",
    height: "65%",
    display: "flex",
    justifyContent: "flex-start",
  },
  rowStyle: {
    display: "flex",
    alignItems: "center",
    height: "100vh",
    overflow: "hidden",
  },
  hoverStyles: {
    backgroundColor: "#E8F3FF",
  },
  typography: { color: "#233658", fontSize: "36px", fontWeight: "700" },
  closeIcon: { fontSize: "22px", cursor: "pointer", color: "#233658" },
  title: { marginLeft: "15px", color: "#233658", fontSize: "18px" },
  drawerTitle: { color: "#233658", fontSize: "20px" },
  drawerContainer: {
    position: "fixed",
    top: 0,
    right: 0,
    width: "300px",
    height: "100%",
    backgroundColor: "white",
    transition: "right 0.3s ease-in-out",
  },
  container: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  imageStyling: {
    width: "35px"
  },
  drawerStyling: {
    display: "flex",
    alignItems: "center"
  },
  mainImageStyling: {
    marginRight: "8px",
    borderRadius: "50%",
    width: "75px",
    height: "75px"
  },
  helpContainer: {
    position: "fixed",
    right: "20px", 
    bottom: "0px",
    width: "200px",
    height: "40px",
    padding: "5px"
  },
  help: {
    color: "#476788",
    fontSize: "18px",
    textDecoration: "underline",
    cursor: "pointer",
    textAlign: "right",
    right: 0,
    bottom: 0,
    position: "absolute"
  
  },
  terms: {
    color: "#476788",
    fontSize: "18px",
    textDecoration: "underline",
    cursor: "pointer",
    textAlign: "left",
    right: 160,
    bottom: 0,
    position: "absolute"
  },
  version: {
    float: "right",
    cursor: "pointer",
    fontWeight: "500",
    textDecoration: "underline"


   }
  
};
